import { lazy, Suspense } from 'react'

import { defineMessages } from 'react-intl'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { vendorReportConfig } from '@webapp/modules/reports/config/reportConfigs'

const ReportAggregateViewChunk = lazy(() =>
  import('../../feature-sets/ReportAggregateView').then(
    ({ ReportAggregateView }) => ({
      default: ReportAggregateView,
    })
  )
)

const scope = `procurify.modules.reports.pages.OrdersByVendorReportPage`

const messages = defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Orders by vendor',
  },
})

export const OrdersByVendorReportPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={[{ name: intl.formatMessage(messages.pageTitle) }]}
    >
      <div data-testid='orders-by-vendor-report-page'>
        <Suspense fallback={null}>
          <ReportAggregateViewChunk reportConfig={vendorReportConfig} />
        </Suspense>
      </div>
    </Page>
  )
}
